import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTickinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M5.546 10.705l7.771-9.357 1.83 1.515-9.601 11.5L0 9.483l1.647-2.054z"
	})
});
export default SvgTickinline;
